import { render, staticRenderFns } from "./MyTeam.vue?vue&type=template&id=0479ea58"
import script from "./MyTeam.vue?vue&type=script&lang=js"
export * from "./MyTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports